import {
  Component, AfterViewChecked,
  ChangeDetectorRef, OnChanges, SimpleChanges,
  OnDestroy, Directive, EventEmitter, Input, Output, QueryList, ViewChildren, ViewChild, OnInit, ViewEncapsulation, HostListener
} from '@angular/core';
import { environment } from '../../../environments/environment';
import {  InvoicesService } from '../../services/invoices.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { BillingPortalProps } from '../../models/BillingPortalProps';
import { HttpClient } from '@angular/common/http';
import { BansStorageService } from '../../services/bans-storage.service';
import { IndexedDbService } from '../../services/indexeddb.service';

interface IInvoice {
  invoice_id: string;
  date: string;
  caContract: string;
  amount: any;
  currency: string;
  status: string;
  statusColor: string;
  status_class: string;
  isSelected: boolean;
  dueDate: string;
  pending_amount: any;
  editedAmountToPay: any;
  invoiceReversalDocumentID: string;
  invoiceReversedDocumentID: string;
  bpNo: string;
  StreetName: string,
  Country: string,
  CityName: string,
  zipCode: string,
  region: string,
  businessPartnerName: string,
  isPaid: boolean,
  isSledCustomer: boolean
}

export type SortColumn = keyof IInvoice | '';
export type SortDirection = 'asc' | 'desc' | '';
const rotate: { [key: string]: SortDirection } = { 'asc': 'desc', 'desc': '', '': 'asc' };

const compare = (v1: string | number, v2: string | number) => v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

export interface SortEvent {
  column: SortColumn;
  direction: SortDirection;
}

@Directive({
  selector: 'th[sortable]',
  host: {
    '[class.asc]': 'direction === "asc"',
    '[class.desc]': 'direction === "desc"',
    '(click)': 'rotate()'
  }
})
export class NgbdSortableHeader {

  @Input() sortable: SortColumn = '';
  @Input() direction: SortDirection = '';
  @Output() sort = new EventEmitter<SortEvent>();

  rotate() {
    this.direction = rotate[this.direction];
    this.sort.emit({ column: this.sortable, direction: this.direction });
  }
}
@Component({
  selector: 'app-historical-invoices',
  templateUrl: './historical-invoices.component.html',
  styleUrls: ['./historical-invoices.component.css'],
  encapsulation: ViewEncapsulation.ShadowDom, // or ViewEncapsulation.none
  //encapsulation:ViewEncapsulation.Emulated,


})
export class HistoricalInvoiceComponent implements OnInit, AfterViewChecked, OnDestroy, OnChanges {
  @Input() token: string = 'initial token!';
  @Input() isAgent: boolean = false;
  
  @ViewChildren(NgbdSortableHeader) headers!: QueryList<NgbdSortableHeader>;
  
  customerIDs: Array<string> = [];
  eventHandler: any;
  banflag: boolean = false;
  invoices: Array<IInvoice> = new Array();
  Allinvoices: Array<IInvoice> = new Array();
  selectedInvoices: Array<IInvoice> = new Array();
  pendingAmountToPay: number = 0;
  totalEditedAmount: number = 0;
  currency: any;
  payStatus: string[] = [];
  checkedInvoiceList: any;
  isMasterSel: boolean;
  checkSingleItem: boolean = true;
  iNumber!: string;
  banCAs = new Map<string, Array<string>>();
  closeResult: string = "";
  ban: string = "";
  cano: string = "";
  isSledCustomer: boolean = false;
  showLoader: boolean = false;
  showbtn!: boolean;
  paymentType: string = "fullAmount";
  showSummary: boolean = false;
  invoicesSearch: string = '';
  isLoading = false;
  currentPage = 1;
  itemsPerPage = environment.itemsPerPage;
  banResponse: any;
  isInvoicesAPICall: boolean = false;
  isAllHistoricalInvoicesLoaded: boolean = true;
  unSupportedBanInvoices: boolean = false;
  permissions: String[] = environment.billingProps.permissions;
  isMakePaymentEnabled: boolean = environment.MakePyamentEnableFlag;
  paymentMessage: String = "You do not have permission to make the payment. Please connect with your system administrator";
  @ViewChild('paymentStatus') paymentStatus: any;
  
  toggleLoading = () => this.isLoading = !this.isLoading;
  BillingPortalProps: BillingPortalProps = new BillingPortalProps();

  constructor(private router: Router,
    private ref: ChangeDetectorRef,
    private invoicesService: InvoicesService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private http: HttpClient,
    private bansService: BansStorageService,
    private indexedDbService: IndexedDbService
  ) {
    let aToken = localStorage.getItem('azuretoken');
    this.token = aToken != null ? JSON.parse(aToken) : '';
    this.isMasterSel = false;

  }

  ngAfterViewChecked(): void {
    const customEvent = new CustomEvent('InvoicesLoaded', {});
    window.dispatchEvent(customEvent);
  }

  ngOnDestroy(): void {
    console.log('Destroying invoices!');
    window.removeEventListener('sendToken', (l: any) => {
      console.log('Removing Listener!');
    });
  }

  async ngOnInit() {
    this.getBans()
  }

  getBans() {
    this.bansService.bans.subscribe((bans: any) => {
      this.bansService.bansApiResponse.subscribe((bansResponse: any) => {
        if (bansResponse) {
          this.banResponse = bansResponse;
        }
      })
      this.banCAs = bans;
      if (bans) {
        this.banCAs = bans;
        let ban = JSON.parse(JSON.stringify(localStorage.getItem("Selected_BAN_Dropdown_Value"))) || "";
        let banCA = JSON.parse(JSON.stringify(localStorage.getItem("Selected_BAN_CAs_Dropdown")));
        let firstBAN: any = this.banCAs.entries().next().value;
        this.ban = ban ? ban : firstBAN[0];
        let selectedBANCA = banCA ? banCA : firstBAN[1];
        var sledBan = this.banResponse && this.banResponse.find((x: { bancust: string; }) => x.bancust == this.ban) || { zzachclass_bus: "", contractacc: "" };
        this.cano = sledBan.contractacc
        this.isSledCustomer = sledBan.zzachclass_bus == 'SLED'
        this.getHistoricalInvoices(this.ban, selectedBANCA, sledBan.zzachclass_bus == 'SLED' ? true : false);
      }
      else{
        this.bansService.banFlag.subscribe(
          (isPresent: boolean) => {
            if(!isPresent){
              this.unSupportedBanInvoices = true;
              this.invoices = [];
              this.Allinvoices = [];
            }
          }
        );
      }
    })
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    if (direction === '' || column === '') {
      this.invoices = this.Allinvoices.slice(0, this.invoices.length);
    } else {
      this.Allinvoices = [...this.Allinvoices].sort((a, b) => {
        if (column.toLocaleLowerCase().includes("date")) {
          if (direction === 'asc')
            return new Date(b[column]).getTime() - new Date(a[column]).getTime();
          else
            return new Date(a[column]).getTime() - new Date(b[column]).getTime();
        } else {
          const res = compare(a[column], b[column]);
          return direction === 'asc' ? res : -res;
        }
      });
      this.invoices = this.Allinvoices.slice(0, this.invoices.length);
    }
  }

  selectedBan() {
    if (this.ban != "BAN") {
      const selectedBan = this.banCAs.get(this.ban) || [""];
      var sledBan = this.banResponse.find((x: { bancust: string; }) => x.bancust == this.ban) || { zzachclass_bus: "", contractacc: "" };
      this.cano = sledBan.contractacc
      this.isSledCustomer = sledBan.zzachclass_bus == 'SLED'
      this.getHistoricalInvoices(this.ban, selectedBan, sledBan.zzachclass_bus == 'SLED' ? true : false);
    }
  }

  onSendTokenEvent(event: any) {
    console.log('Receiveed Token is - ', event);
    this.token = event?.detail;
    window.removeEventListener('sendToken', this.eventHandler, true);
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(JSON.stringify(changes));
    if (changes['token'].currentValue != changes['token'].previousValue) {
      const curr = changes['token'].currentValue;
      console.log(curr);
    }
  }

  async getHistoricalInvoices(banNo: string, contractAcc: string[], isSledCustomer: any) {
    this.banflag = false;
    this.invoices = new Array();
    console.log("inside getinvoice" + this.invoices.length);
    let cachedInvoices = await this.indexedDbService.getHistoricalInvoices(banNo);
    if (cachedInvoices && cachedInvoices.length) {
      this.Allinvoices = cachedInvoices;
      this.invoices = this.Allinvoices.slice(0, this.itemsPerPage);
      let isLoadMoreClicked = await this.indexedDbService.getLoadInvoiceCheck(banNo);      
      if(isLoadMoreClicked){
        this.loadMoreHistoricalInvoices();
      }
      else{
        this.resetLoadMoreButton();
      }
    }
    else{
      this.invoicesService
      .getHistoricalInvoiceHeader(banNo, contractAcc)
      .subscribe(async(res: any) => {
        res.forEach((element: any) => {
          let statusColor = '';
          const invoiceStatus = new String(element.STATUS);
          if (invoiceStatus.toUpperCase() == 'NOT PAID') statusColor = '#ffd6d6';
          else if (invoiceStatus.toUpperCase() == 'PAID') statusColor = '#d6f8d2';
          else if (invoiceStatus.toUpperCase() == 'PARTIALLY PAID') statusColor = '#fedcc3';

          var bill = {
            invoice_id: element.INVNO,
            date: `${element.INVDATE.toString().slice(4, 6)}/${element.INVDATE.toString().slice(6, 8)}/${element.INVDATE.toString().slice(0, 4)}`,
            caContract: element.CA_CONTRACT || '',
            amount: element.BALANCE,
            currency: element.CURRENCY || '',
            status: element.STATUS,
            statusColor: statusColor,
            status_class: 'btn-success ac-inv-paid',
            isSelected: false,
            dueDate: `${element.DUEDATE.toString().slice(4, 6)}/${element.DUEDATE.toString().slice(6, 8)}/${element.DUEDATE.toString().slice(0, 4)}`,
            pending_amount: element.PENDING_AMOUNT || '0',
            editedAmountToPay: parseFloat(element.PENDING_AMOUNT || '0').toFixed(2),
            invoiceReversalDocumentID: element.INVOICE_REVERSAL_DOCUMENT_ID || '',
            invoiceReversedDocumentID: element.INVOICE_REVERSED_DOCUMENT_ID || '',
            bpNo: element.BAN,
            StreetName: element.STREET,
            Country: element.COUNTRY || '',
            CityName: element.CITY1,
            zipCode: element.POST_CODE1,
            region: element.REGION || '',
            businessPartnerName: element.ACC_NAME,
            isPaid: element.STATUS.toUpperCase() === 'PAID' || element.STATUS.toUpperCase() === 'REVERSED' || parseFloat(element.PENDING_AMOUNT || '0') <= 0,
            isSledCustomer: isSledCustomer
          };
          if (this.invoices.findIndex((item) => item.invoice_id === bill.invoice_id) < 0) {
            this.invoices.push(bill);
          }
        });
        this.invoices = this.invoices.sort((a: any, b: any) => {
          return <any>new Date(b.date).getTime() - <any>new Date(a.date).getTime();
        });
        this.Allinvoices = this.invoices;
        this.invoices = this.Allinvoices.slice(0, this.itemsPerPage);
        await this.indexedDbService.storeHistoricalInvoices(banNo, this.Allinvoices);
        this.banflag = true;
        this.resetLoadMoreButton();
      });
    }
  }

  resetLoadMoreButton() {
    if (this.invoices.length === this.Allinvoices.length) {
      this.isAllHistoricalInvoicesLoaded = true;
    }else{
      this.isAllHistoricalInvoicesLoaded = false;
    }
  }

  loadMoreHistoricalInvoices = async() => {
    await this.indexedDbService.storeHistoricalInvoices(this.ban, this.Allinvoices, true);
    if (this.invoices.length < this.Allinvoices.length) {
      this.appendData();
    } else if (this.invoices.length === this.Allinvoices.length) {
      this.isAllHistoricalInvoicesLoaded = true;
    }
  }
  
  appendData() {
    this.invoices = [...this.Allinvoices];
    this.resetLoadMoreButton();
  }

  public addBill(invoice: IInvoice) {
    if (!invoice.isSelected) {
      this.pendingAmountToPay += +invoice.pending_amount;
      this.currency = invoice.currency;
      this.iNumber = invoice.invoice_id;
      this.payStatus.push(invoice.status);
      this.selectedInvoices.push(invoice);
    } else {
      this.pendingAmountToPay -= -invoice.pending_amount;
      this.currency = invoice.currency;
      this.iNumber = "";
      this.payStatus.push("");
      this.selectedInvoices.forEach((ele, index) => {
        console.log("inside for")
        if (ele.invoice_id == invoice.invoice_id) {
          this.selectedInvoices.splice(index, 1);
        }
      });
      this.payStatus.forEach((element, index) => {
        if (element == invoice.status) {
          this.payStatus.splice(index, 1);
        }
      });
    }
  }

  openPaidAlert(content: any) {
    this.modalService.open(content,
      { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult =
          `Dismissed ${this.getDismissReason(reason)}`;
      });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  pay() {
    localStorage.removeItem("ban")
    localStorage.removeItem("cano")
    localStorage.removeItem("isSledCustomer")
    localStorage.removeItem("totalAmountToPay")
    localStorage.removeItem("InvoiceList")
    if (this.isMakePaymentEnabled && this.permissions.includes('BI-MP')) {
      localStorage.setItem("ban", this.ban)
      localStorage.setItem("cano", this.cano)
      localStorage.setItem("isSledCustomer", this.isSledCustomer + "")
      this.router.navigate(["../summary"], { relativeTo: this.route });
      return;
    } else {
      this.openPaymentPermissionDeniedModal();
    }
  }

  openPaymentPermissionDeniedModal() {
    const modalRef = this.modalService.open(this.paymentStatus);
    modalRef.result.then((result) => {
      console.log('Modal closed', result);
    }).catch((error) => {
      console.log('Modal dismissed', error);
    });
  }

  cancel() {
    this.showSummary = false;
    this.router.navigate(["invoices"]);
  }

  async payBills() {
    console.log(this.selectedInvoices)
    localStorage.setItem("CreatSB", "false");
    localStorage.setItem("InvoiceList", JSON.stringify(this.selectedInvoices));
    this.router.navigate(["checkout"], { relativeTo: this.route });
  }

  viewInvoice(item: any) {
    this.router.navigate(["../" + item.invoice_id], { relativeTo: this.route, state: { 'invoice': item } });
  }

  selectBan(selectedBan: string): void {
    this.ban = selectedBan;
    this.invoicesSearch = '';
    if (this.ban != "BAN") {
      const selectedBan = this.banCAs.get(this.ban) || [""];
      var sledBan = this.banResponse.find((x: { bancust: string; }) => x.bancust == this.ban) || { zzachclass_bus: "" };
      this.getHistoricalInvoices(this.ban, selectedBan, sledBan.zzachclass_bus == 'SLED' ? true : false);
    }
  }

  downloadCSV() {
    if (this.Allinvoices.length) {
      let data = this.makeCSV(this.Allinvoices);
      this.fileDownload(data);
    }
  }

  fileDownload(data: any) {
    const blob = new Blob([data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('href', url);
    a.setAttribute('download', `${this.ban}-Historical-Invoice-List.csv`);
    a.click();
  }

  makeCSV(data: any) {
    const fieldMapping: { [key: string]: string } = {
        invoice_id: "Invoice No.",
        date: "Invoice Date",
        caContract: "Contract Accounts",
        amount: "Invoice Amount",
        currency: "Currency",
        status: "Invoice Status",
        dueDate: "Due Date",
        pending_amount: "Pending Amount",
        editedAmountToPay: "Edited Amount To Pay",
        invoiceReversalDocumentID: "Invoice Reversal ID",
        invoiceReversedDocumentID: "Invoice Reversed ID",
        bpNo: "BP Number",
        businessPartnerName: "BP Name",
        isPaid: "Is Paid",
        isSledCustomer: "Is Sled Customer"
    };
    const headers = Object.keys(fieldMapping);
    const csvHeaders = headers.map(key => fieldMapping[key]);
    const csvContent = [];
    csvContent.push(csvHeaders.join(','));
    data.forEach((item: any) => {
        const row: any = headers.map(header => {
            let value = item[header];
            if (typeof value === 'string' && value.includes(',')) {
                value = `"${value}"`;
            }
            return value;
        });
        csvContent.push(row.join(','));
    });
    return csvContent.join('\n');
}

  get getInvoicesList() {
    let searchArray = [];
    if (this.invoicesSearch) {
      for (let invoice of this.invoices) {
        if (invoice.invoice_id.includes(this.invoicesSearch.toLowerCase())) {
          searchArray.push(invoice);
        }
      }
      this.checkloadMoreBtnStatus(searchArray)
      return searchArray;
    }
    else {
      this.checkloadMoreBtnStatus(this.invoices)
      return this.invoices;
    }
  }

  checkloadMoreBtnStatus(searchArray: any){
    if((this.invoices.length === this.Allinvoices.length) || searchArray.length < this.itemsPerPage) {
      this.isAllHistoricalInvoicesLoaded = true;
    }
    else{
      this.isAllHistoricalInvoicesLoaded = false;
    }
  }
}